<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/175ekuE/tc-custom/9781497613539.jpg?1733030046456" alt="This image is the cover for the book Castle Perilous, Castle Perilous"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Castle Perilous, Castle Perilous
      </h1>
      <p class="bookDescription body article font2">
        <b>Welcome to the wild and wacky alternate worlds fantasy series. “I’ve enjoyed every book DeChancie has written!” (Steven Brust, <i>New York Times</i>–bestselling author).</b><br/>  <br/> Imagine life in an ironically magical world where 144,000 doors separate fiction from reality. A place that can hypnotize even the most grounded philosophy major and deliver a fantastical rhyme to his reason. A place where a best buddy resembles a shaggy carpet, and adventures surpass a boy's dreams . . . welcome to Castle Perilous.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        John DeChancie
      </h2>
      
      <p class="authorDescription body article">John DeChancie is a popular author of numerous science fiction and fantasy novels, including the hugely entertaining&#160;Castle&#160;series and the&#160;Starrigger&#160;trilogy. He grew up near Pittsburgh, Pennsylvania, and now lives in Los Angeles, California.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?3848da3d